import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  install (Vue) {
    Vue.prototype.getPdf = function (idStr, title) {
      let ele = document.querySelector('#' + idStr).children[1]
      ele.className = `export_report hind`;
      html2Canvas(document.querySelector('#' + idStr), {
        // allowTaint: true,
        useCORS: true,
        scale: 2, // 提升画面质量，但是会增加文件大小
      }).then((canvas) => {
        let context = canvas.getContext('2d')
        context.mozImageSmoothingEnabled = false
        context.webkitImageSmoothingEnabled = false
        context.msImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let img = new Image()
        img.src = pageData
        img.onload = function () {
          // 获取dom高度、宽度
          img.width = img.width / 2
          img.height = img.height / 2
          img.style.transform = 'scale(0.5)'
          if (img.width > img.height) {
            // 此可以根据打印的大小进行自动调节
            // eslint-disable-next-line
            var pdf = new JsPDF('l', 'mm', [
              img.width * 0.28,
              img.height * 0.28
            ])
          } else {
            // eslint-disable-next-line
            var pdf = new JsPDF('p', 'mm', [
              img.width * 0.28,
              img.height * 0.28
            ])
          }
          pdf.addImage(
            pageData,
            'jpeg',
            0,
            0,
            img.width * 0.28,
            img.height * 0.28
          )
          pdf.save(title + '.pdf')
          ele.className = `export_report`;

        }
        // pdf.save(title + '.pdf')
      })
    }
  },
}